import { Blob } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { Typography } from 'src/components/atoms';
import { Flex } from 'src/components/layout';
import { RoundedButton } from 'src/components/molecules';
import { Dialog } from 'src/components/organisms';
import { useConvertSecondsToDHMinSec } from '../helpers';

interface Props {
  onClose: () => void;
  currentTimeToUnlock: Blob['currentTimeToUnlock'];
}

export const TimeBasedWaitingDialog = ({ onClose, currentTimeToUnlock }: Props) => {
  const { t } = useTranslation();

  const convertSeconds = useConvertSecondsToDHMinSec(currentTimeToUnlock);

  return (
    <Dialog
      title={t('pages.mymes.details.content.not_available_blob_title_dialog')}
      onClose={onClose}
      defaultActionButtons={{
        btnConfirmText: undefined
      }}
      actionButtons={
        <Flex justifyContent='center' width='100%'>
          <RoundedButton onClick={onClose} color='primary'>
            {t('pages.reset_password.reset_success_dialog.btn')}
          </RoundedButton>
        </Flex>
      }
      enableBackdropClick
      enableEscapeKeyDown
    >
      <Typography>{t('pages.mymes.details.unlock_blob_in', { timeToUnlock: convertSeconds })}</Typography>
    </Dialog>
  );
};
